// Top-level fallback rendered when a render-time error escapes a child
// component. Sentry has already received the event by the time this
// renders. The "Try again" button resets the boundary's internal error
// state so the tree re-mounts; if the bug is deterministic the user
// will land here again, which is the right outcome — better than a
// silent loop.

import { AppShell, Button, Card, CardBody, Container, Stack } from './ui';

export function ErrorFallback({ resetError }: { resetError: () => void }) {
  return (
    <AppShell>
      <Container width="base">
        <Card>
          <CardBody size="lg">
            <Stack gap={4}>
              <h1 style={{ fontSize: 'var(--fs-2xl)' }}>Something went wrong</h1>
              <p className="ds-text-muted">
                The page hit an error and stopped rendering. The team has been notified.
                You can try again, or go back to the home page.
              </p>
              <Stack gap={2} as="div" className="ds-mt-4">
                <Button variant="primary" onClick={resetError}>
                  Try again
                </Button>
                <Button
                  variant="ghost"
                  onClick={() => {
                    window.location.href = '/';
                  }}
                >
                  Back to home
                </Button>
              </Stack>
            </Stack>
          </CardBody>
        </Card>
      </Container>
    </AppShell>
  );
}
